import $ from 'jquery';
import {setCookie, deleteCookie, getCookie} from './cookies';
import AjaxDataSend from './shopEcp/ajaxDataSend';

window.$ = $;
window.jQuery = $;
const over = (method, on, off) => {
    const old = window.XMLHttpRequest.prototype[method];

    if (!old.old) {
        const stack = [];
        window.XMLHttpRequest.prototype[on] = (fn) => {
            if (typeof fn === 'function') {
                stack.push(fn);
            }
        };
        window.XMLHttpRequest.prototype[off] = (fn) => {
            for (let i = 0, l = stack.length; i < l; i += 1) {
                if (stack[i] === fn) {
                    stack.splice(i, 1);
                    break;
                }
            }
        };
        window.XMLHttpRequest.prototype[method] = function() {
            const args = Array.prototype.slice.call(arguments);
            const ret = old.apply(this, args);

            for (let i = 0, l = stack.length; i < l; i += 1) {
                stack[i].apply(this, args);
            }

            return ret;
        };
        window.XMLHttpRequest.prototype[method].old = old;
        const originalSetRequestHeader = XMLHttpRequest.prototype.setRequestHeader;

        XMLHttpRequest.prototype.setRequestHeader = function(header, value) {
            if (!this._customHeaders) {
                this._customHeaders = {};
            }

            if (this._customHeaders[header]) {
                return;
            }

            this._customHeaders[header] = value;
            originalSetRequestHeader.call(this, header, value);
        };
    }
};
over('open', 'onOpen', 'offOpen');
XMLHttpRequest.prototype.onOpen(function() {
    this.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
});

$.ajaxSetup({
    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
});
var cookies = {};
let cookiesSplit = document.cookie.split(`; `);
for (let cookie of cookiesSplit) {
    let parts = cookie.split(`=`);
    cookies[parts[0]] = parts[1];
}

/* setInterval(function () {
  AjaxDataSend(
    {
      url: "/ajax/session-update/",
      data: {},
      onSuccess: function actionSessionUpdate(response) {
        if((response.success == true) && (typeof response.token != 'undefined')){
          $("meta[name='csrf-token']").attr("content", response.token);
          $.ajaxSetup({
            headers:
              { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') }
          });
        }
      },
      onError: function () {
        console.log('Session update fail');
      },
    }
  )
}, 900000); */
function checkCookiebotCookies() {
    let consent = getCookie('CookieConsent');
    let marketing = false;
    let statistics = false;
    let preferences = false;
    if (typeof consent !== 'undefined') {
        let stringParts = consent.split(',');
        stringParts.forEach(function(part) {
            if (part.indexOf('preferences') > -1 && part.indexOf('true') > -1) {
                preferences = true;
                return;
            }
            if (part.indexOf('statistics') > -1 && part.indexOf('true') > -1) {
                statistics = true;
                return;
            }
            if (part.indexOf('marketing') > -1 && part.indexOf('true') > -1) {
                marketing = true;
                return;
            }
        });
    }
    let result = {};
    result.marketing = marketing;
    result.statistics = statistics;
    result.preferences = preferences;
    return result;
}

function checkCookiePreferences() {
    let consent = getCookie('CookieConsent');
    let result = false;
    if (typeof consent !== 'undefined' && consent.indexOf('preferences:true') > -1) {
        result = true;
    }
    window.checkCookiePreferences = result;
};

window.checkCookiebotCookies = checkCookiebotCookies;
window.checkCookiePreferences = checkCookiePreferences;
window.reCAPTCHAv3 = function(SiteKey, Action) {
    if (!document.body.classList.contains(`grecaptcha-is-ready`)) {
        return null;
    }
    return new Promise((res, rej) => {
        grecaptcha.execute(SiteKey, {action: `${Action}${location.pathname.replace(/[^A-Za-z\/_]/g, `_`)}`}).then(function(token) {
            return res(token);
        });
    });
};
window.onload = function() {
    let secure = location.protocol === 'https:' ? `secure;` : ``;
    if (cookies[`gdpr`] != 0) {
        let gscsJSON = localStorage.getItem(`gscs`);
        if (gscsJSON !== null) {
            let gscs = JSON.parse(gscsJSON);
            if (gscs.source !== ``) {
                document.cookie = `HTTP_REFERER_GOOGLE=${gscs.source};path=/;${secure}samesite=strict`;
            }
        }
    }
};

// замена ip на тестовой среде
$('.ip-button').on('click', function() {
    $('.ip-container').toggle();
});

$('.ip-close-button').on('click', function() {
    $('.ip-container').hide();
});

$('.ip-inner-container').on('submit', function(event) {
    event.preventDefault();
    if ($('.ip-field').val() != '') {
        let cookieExpirationTime = new Date().getTime() + 86400000;
        let cookieProps = {
            'exp': cookieExpirationTime, 'path': '/',
        };
        let customIp = $('.ip-field').val();
        setCookie('custom-ip', customIp, cookieProps);
    }
});

$('.ip-cancel-button').on('click', function() {
    deleteCookie('custom-ip', '0.0.0.0');
});

function wrapWordsColorOutline(container) {
    if (!container) return;
    const walker = document.createTreeWalker(
        container,
        NodeFilter.SHOW_TEXT,
        {
            acceptNode: (node) => {
                return node.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
            }
        }
    );
    const textNodes = [];
    while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
    }
    textNodes.forEach(node => {
        const words = node.nodeValue.split(/(\s+)/);
        const fragment = document.createDocumentFragment();
        words.forEach(word => {
            if (word.trim()) {
                const span = document.createElement('span');
                span.className = 'ns-text-outline';
                span.textContent = word;
                fragment.appendChild(span);
            } else {
                fragment.appendChild(document.createTextNode(word));
            }
        });
        node.parentNode.replaceChild(fragment, node);
    });
}

$(document).ready(function() {
    if (getCookie('custom-ip') != 'undefined') {
        let customIp = getCookie('custom-ip');
        $('.ip-field').val(customIp);
    }
});
// замена ip на тестовой среде

$(document).ready(function() {
    //смена языка в футере
    $(document).mouseup(function(e) {
        let languageMenu = $('.ecp-footer__change-language-list');
        let languageBar = $('.ecp-footer__change-lang-container');
        if (e.target === $('.ecp-footer__change-lang-current')[0]) {
            languageBar.toggleClass('open');
            $('.ecp-footer__change-language-list').toggleClass('active');
        } else if ($('.ecp-footer__change-language-list').hasClass('active')) {
            if (!languageMenu.is(e.target) && e.target !== $('.ecp-footer__change-lang-current')[0]) {
                languageMenu.removeClass('active');
                languageBar.removeClass('open');
            }
        }

    });

    function detectZoom() {
        const zoom = window.outerWidth / window.innerWidth;
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /Mobi|Android|iPhone|iPad|Tablet/i.test(userAgent);
        if (isMobile) {
            const zoom = screen.width / window.innerWidth;
            return +zoom.toFixed(2);
        }
        const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
        if (isFirefox) {
            const systemZoom = window.screen.width / window.innerWidth;
            const dpr = window.devicePixelRatio;
            return (1 + (dpr - systemZoom)/systemZoom).toFixed(2);
        }
        return +zoom.toFixed(2);
    }

    function checkMegazoom() {
        const ratio = detectZoom();
        const body = document.querySelector("body");
        if (ratio >= 2){
            if(!body.classList.contains("ns-zoom-200")){
                body.classList.add("ns-zoom-200");
            }
        }
        else{
            if(body.classList.contains("ns-zoom-200")){
                body.classList.remove("ns-zoom-200");
            }
        }
    }

    //смена языка в хедере
    $(document).mouseup(function(e) {
        let languageMenu = $('.ecp-header__change-language-list');
        let languageBar = $('.ecp-header__change-lang-container');
        if (e.target === $('.ecp-header__change-lang-current')[0]) {
            languageBar.toggleClass('open');
            $('.ecp-header__change-language-list').toggleClass('active');
        } else if ($('.ecp-header__change-language-list').hasClass('active')) {
            if (!languageMenu.is(e.target) && e.target !== $('.ecp-header__change-lang-current')[0]) {
                languageMenu.removeClass('active');
                languageBar.removeClass('open');
            }
        }
    });

    checkMegazoom();
    window.addEventListener('resize', () => {
        checkMegazoom();
    })

    const wrapContainersArray1 = document.querySelectorAll(".ns-accent-text");
    wrapContainersArray1.forEach((wrapContainer) => {
        wrapWordsColorOutline(wrapContainer);
    });
    const wrapContainersArray2 = document.querySelectorAll(".store__heading-h1 span");
    wrapContainersArray2.forEach((wrapContainer) => {
        wrapWordsColorOutline(wrapContainer);
    });
});
